export default "__VITE_PUBLIC_ASSET__c9eabce2__"